export type NetworkSpeed =
  | 'fast'
  | 'moderate'
  | 'slow'
  | 'very_slow'
  | 'not_set';

/**
 * Classifies network speed based on the given speed in megabits per second (Mbps).
 *
 * @param mbps - The network speed in megabits per second.
 * @returns A string representing the network speed classification.
 **/
export const classifyNetworkSpeed = (mbps?: number): NetworkSpeed => {
  if (!mbps) {
    return 'not_set';
  } else if (mbps >= 1.5) {
    return 'fast';
  } else if (mbps >= 1) {
    return 'moderate';
  } else if (mbps >= 0.5) {
    return 'slow';
  } else {
    return 'very_slow';
  }
};
